export enum ProjectionIndicatorCategory {
  activity = 'activity',
  director = 'director',
  taxation = 'taxation',
  financial = 'financial'
}
